import { UTM_TAGS } from '@/enums';

export default function useUtm() {
  function extractUtm(query) {
    if (process.server) {
      return;
    }

    UTM_TAGS.forEach((tag) => {
      if (localStorage.getItem(tag) === null && query[tag]) {
        localStorage.setItem(tag, query[tag]);
      }
    });
  }

  function getUtm() {
    if (process.server) {
      return {};
    }

    const utm = {};

    UTM_TAGS.forEach((tag) => {
      if (localStorage.getItem(tag) !== null) {
        utm[tag] = localStorage.getItem(tag);
      }
    });

    return utm;
  }

  return {
    extractUtm,
    getUtm,
  };
}
